const STEM_KEYWORDS = [
  "medicine",
  "pharmacy",
  "engineering",
  "science",
  "nursing",
  "dentistry",
  "veterinary",
  "computing",
  "data science",
  "physical",
];

export type FacultyGroup = "stem" | "humanities";

export type FacultyOption = {
  value: string;
  label: string;
};

export function getFacultyOptions(): FacultyOption[] {
  return [
    { value: "Medicine", label: "Medicine" },
    { value: "Pharmacy", label: "Pharmacy" },
    { value: "Dentistry", label: "Dentistry" },
    { value: "Nursing", label: "Nursing" },
    { value: "Science", label: "Science" },
    { value: "Engineering", label: "Engineering" },
    { value: "Commerce", label: "Commerce" },
    { value: "Law", label: "Law" },
    { value: "Arts", label: "Arts" },
    { value: "Education", label: "Education" },
  ];
}

export function getFacultyGroup(faculty: string | null): FacultyGroup {
  if (!faculty) return "stem";
  const lower = faculty.toLowerCase();
  return STEM_KEYWORDS.some((keyword) => lower.includes(keyword)) ? "stem" : "humanities";
}

export const STEM_WEAK_POINTS = [
  "Can't understand the core concept",
  "Understand but can't apply",
  "Forget quickly",
  "Can't solve problems",
  "Theory is hard",
  "Practical / calculations are hard",
] as const;

export const HUMANITIES_WEAK_POINTS = [
  "Can't memorize",
  "Can't connect topics together",
  "Writing and expression is hard",
  "Terms and definitions are hard",
  "Analysis and critique is hard",
] as const;

export function getWeakPointOptions(faculty: string | null) {
  return getFacultyGroup(faculty) === "stem" ? STEM_WEAK_POINTS : HUMANITIES_WEAK_POINTS;
}
